import { API_PDC_URL_V2, API_PDC_URL_V3 } from "../../../config";
import moment from "moment";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { getQueryString } from "../../services/rest-api-call";

export const accountantConstants = {
  GET_EFFECTIVE_OR_NOT_START: "GET_EFFECTIVE_OR_NOT_START",
  GET_EFFECTIVE_OR_NOT_SUCCESS: "GET_EFFECTIVE_OR_NOT_SUCCESS",
  GET_EFFECTIVE_OR_NOT_ERROR: "GET_EFFECTIVE_OR_NOT_ERROR",
  GET_EFFECTIVE_OR_NOT_CLEAR: "GET_EFFECTIVE_OR_NOT_CLEAR",

  CREATE_MERGED_DEADLINE_START: "CREATE_MERGED_DEADLINE_START",
  CREATE_MERGED_DEADLINE_SUCCESS: "CREATE_MERGED_DEADLINE_SUCCESS",
  CREATE_MERGED_DEADLINE_ERROR: "CREATE_MERGED_DEADLINE_ERROR",

  GET_DEADLINES_COUNTERPARTS_START: "GET_DEADLINES_COUNTERPARTS_START",
  GET_DEADLINES_COUNTERPARTS_SUCCESS: "GET_DEADLINES_COUNTERPARTS_SUCCESS",
  GET_DEADLINES_COUNTERPARTS_ERROR: "GET_DEADLINES_COUNTERPARTS_ERROR"
};

export function clearGetEffectiveOrNot(){
  return (dispatch) => {
    dispatch({
      type: accountantConstants.GET_EFFECTIVE_OR_NOT_CLEAR     
    });
  };
}
/** TODO agganciare al BE con gestione scroll infinito */
/**
 *
 * @param {*} isWithoutCompany: se la company deve risultare null nella richieta
 * @param {*} nextUrl
 * @param {*} isReset
 * @param {*} queryParameters
 * @param {*} isFiltersActiveToUpdate
 * @returns
 */
export function getEffectiveOrNot(
  isWithoutCompany,
  nextUrl,
  isReset,
  queryParameters = {},
  // tengo traccia del filtro che serve in tabella generale e voglio mantenere o meno
  isFiltersActiveToUpdate
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const companyUuidSelected = !isWithoutCompany ? main.companyUuidSelected : null;
    const companyCf = !isWithoutCompany ? main.clientIdSelected : null;
    const accountantCf = main.accountantSelected;
    const accountantUuidSelected = main.accountantUuidSelected;
    
    let index = -1;
    if (queryParameters.status) {
      if (typeof queryParameters.status === "string") {
        queryParameters.status = [queryParameters.status];
      }
      if (queryParameters.status.indexOf("due_out") !== -1) {
        index = queryParameters.status.indexOf("due_out");
        queryParameters.status[index] = "to_be_paid";
      } else if (queryParameters.status.indexOf("due_in") !== -1) {
        index = queryParameters.status.indexOf("due_in");
        queryParameters.status[index] = "to_be_collected";
      } else if (queryParameters.status.indexOf("paid_out") !== -1) {
        index = queryParameters.status.indexOf("paid_out");
        queryParameters.status[index] = "paid";
      } else if (queryParameters.status.indexOf("paid_in") !== -1) {
        index = queryParameters.status.indexOf("paid_in");
        queryParameters.status[index] = "collected";
      }
    }
    const params = nextUrl
      ? {}
      : {
        itemId: companyUuidSelected || queryParameters.itemId, // companyId || queryParameters.itemId,
        managerId: accountantUuidSelected, // accountantId,
        fromDate: queryParameters.specificDate ? queryParameters.specificDate : queryParameters.fromDate,
        toDate: queryParameters.specificDate ? queryParameters.specificDate : moment(queryParameters.toDate).endOf("day").toISOString(),
        type: queryParameters.type,
        scope: queryParameters.scopes,
        viewed: queryParameters.viewed,
        archived: queryParameters.archived,
        confirmed: queryParameters.confirmed,
        paymentType: queryParameters.paymentType,
        paymentMode: queryParameters.paymentMode,
        paymentStep: queryParameters.status,
        verification: queryParameters.verification,
        counterpartTaxId: queryParameters.counterpartTaxId,
        counterpartDescription: queryParameters.counterpartDescription,
        sameAttachmentsAs: queryParameters.sameAttachmentsAs,
        expired: queryParameters.expired,
        // paymentStatus: queryParameters.paymentStatus,
        itemTaxRegime: queryParameters.itemTaxRegime,
        first: queryParameters.first ? queryParameters.first : "10",
        reconciliated: queryParameters.reconciliated,
        movementAmount: queryParameters.movementAmount,
        after: "0"
      };

    let newParams = getQueryString(params);
    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: accountantConstants.GET_EFFECTIVE_OR_NOT_START,
        payload: {
          isReset: isReset
        }
      });
      let request = {
        method: "GET",
        url: nextUrl ? nextUrl : API_PDC_URL_V3 + "/deadlines" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          "X-Manager-ID": accountantCf,
          "X-Item-ID": companyCf
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {          
          dispatch({
            type: accountantConstants.GET_EFFECTIVE_OR_NOT_SUCCESS,
            payload: {
              data: response.data,
              isReset: isReset,
              queryParameters: queryParameters,
              isFiltersActiveToUpdate: isFiltersActiveToUpdate
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: accountantConstants.GET_EFFECTIVE_OR_NOT_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}

export function createMergedDeadline(
  deadlines, title, date, payment, deadlineCompensationDate
) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };
  
    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PDC_URL_V2}/deadlines/merge`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders 
        },
        data: {
          date: date,
          title: title ? title : "zero",
          deadlinesId: deadlines,
          paymentModeId: payment ? payment : "PM01",
          paymentExecutionDate: deadlineCompensationDate
        }
      };

      dispatch({
        type: accountantConstants.CREATE_MERGED_DEADLINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: accountantConstants.CREATE_MERGED_DEADLINE_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: accountantConstants.CREATE_MERGED_DEADLINE_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: accountantConstants.CREATE_MERGED_DEADLINE_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function getDeadlinesCounterparts() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const companyUuidSelected = main.companyUuidSelected;
    const accountantUuidSelected = main.accountantUuidSelected;

    const params = {
      itemId: companyUuidSelected,
      managerId: accountantUuidSelected // accountantId,
    };

    let newParams = getQueryString(params);

    newParams = newParams !== "" ? `?${newParams}` : "";

    return new Promise(function(resolve, reject) {
      dispatch({
        type: accountantConstants.GET_DEADLINES_COUNTERPARTS_START,
        payload: {
          data: []
        }
      });
      let request = {
        method: "GET",
        url: API_PDC_URL_V3 + "/deadlines/counterparts" + newParams,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          "X-Manager-ID": accountantUuidSelected,
          "X-Item-ID": companyUuidSelected
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: accountantConstants.GET_DEADLINES_COUNTERPARTS_SUCCESS,
            payload: {
              data: response.data._embedded.counterparts
            }
          });
          resolve(response.data._embedded.counterparts);
        })
        .catch((err) => {
          dispatch({
            type: accountantConstants.GET_DEADLINES_COUNTERPARTS_ERROR,
            payload: { error: err }
          });
          reject();
        });
    });
  };
}
